export const app = {
  name: '電動車充電管理',
  subtitle: '管理控制台',
};